
import { Col, Container, Row } from 'react-bootstrap';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import validator from 'validator';
import Button from '../../Component/Button/Button';
import CustomPhoneInput from '../../Component/CustomPhoneInput';
import DropDown from '../../Component/DropDown/DropDown';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import Input from '../../Component/Input/Input';
import TextArea from '../../Component/TextArea';
import { imageUrl } from '../../config/apiUrl';
import { usePostApiMutation } from '../../store/apiSlice/apiSlice';
import { getSelectedLanguagePage } from '../../utils/helpers';
import classes from './ContactUs.module.css';

const ContactUs = () => {
  const { t } = useTranslation('webCommon');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [inquiries, setInquiries] = useState(null);
  const [description, setDescription] = useState('');
  const { contactDetails } = useSelector((state) => state?.commonReducer);

  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { cmsPages } = useSelector((state) => state.commonReducer);
  const pageData = getSelectedLanguagePage(selectedLanguage, cmsPages, 'contactUs');

  const d = (e) => t(`contactUsPage.${[e]}`);
  const [postApiFunc] = usePostApiMutation();

  const handleSubmit = async () => {
    const body = {
      fullName: name,
      phoneNumber: phone,
      message: description,
      email,
      inquiryType: inquiries
    };
    for (let key in body) {
      if (!body[key]) {
        return toast.error(d('toast.requiredFieldsError'));
      }
    }
    if (!validator.isEmail(email)) {
      return toast.error(d('toast.validEmailError'));
    }
    if (!validator.isMobilePhone(phone)) {
      return toast.error(d('toast.validPhoneError'));
    }
    body.inquiryType = [inquiries?.value];
    const res = await postApiFunc({
      url: `contact-us`,
      tag: `ContactUs`,
      method: 'POST',
      data: body
    });
    if (res?.data) {
      setName('');
      setEmail('');
      setPhone('');
      setInquiries('');
      setDescription('');
      toast.success(d('toast.success'));
    }
  };

  return (
    <div className={classes.page}>
      <Header containerClass="" />
      <div className={classes?.containerWrapper}>
        <Container className="">
          <Row className={classes.row}>
            <Col lg={{ span: 6 }} xs={{ span: 12 }}>
              <div className={classes.imgDiv}>
                <img 
                alt={pageData?.data?.photo}
                draggable={false}
                src={imageUrl(pageData?.data?.photo)} />
              </div>
            </Col>
            <Col lg={{ span: 6 }} xs={{ span: 12 }}>
              <h2>{pageData?.data?.tagLine}</h2>
              <ul className={classes.infoSection}>
                <li>
                  {/* <img src={ContactUsLocIcon} /> */}
                  <p>{d('address')}</p>
                  <span>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="http://maps.google.com/?q=Plot No-404-405, 5th Floor, Sector-20, Udyog Vihar, Phase-III, Gurugram, Haryana- 122016">
                      Plot No-404-405, 5th Floor, Sector-20, Udyog Vihar, Phase-III, Gurugram,
                      Haryana- 122016
                    </a>
                  </span>
                </li>
                <li>
                  <p>{d('phone')}</p>
                  {/* <img src={ContactUsPhoneIcon} /> */}
                  <div>
                    <a href={`tel:${contactDetails?.phone}`} target="_blank" rel={'noreferrer'}>
                      {contactDetails?.phone}
                    </a>
                    {/* <a href="tel:+91-124-4698450" target="_blank" rel={'noreferrer'}>
                      +91-124-4698450
                    </a> */}
                  </div>
                </li>
                <li>
                  <p>{d('email')}</p>

                  {/* <img src={ContactUsEmailIcon} /> */}
                  <a href={`mailto:${contactDetails?.email}`} target="_blank" rel={'noreferrer'}>
                    {contactDetails?.email}
                  </a>
                </li>
                <li>
                  <p>whatsapp</p>
                  {/* <img src={whatsappIcon} /> */}
                  <a
                    href={`https://wa.me/${contactDetails?.whatsapp}`}
                    target="_blank"
                    rel={'noreferrer'}>
                    {contactDetails?.whatsapp}
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
      <Container className={classes.bottomContainer}>
        <Row className={classes.bottomRow}>
          <Col sm={12}>
            <h2>
             
              {pageData?.data?.title}
            </h2>
            <p className={classes.infoLine}>{pageData?.data?.description}</p>
          </Col>

          <Col sm={12} lg={6}>
            <Input value={name} setValue={setName} placeholder={d('fullName')} />
          </Col>
          <Col sm={12} lg={6}>
            <Input value={email} setValue={setEmail} placeholder={d('email')} type="email" />
          </Col>
          <Col sm={12} lg={6}>
            <CustomPhoneInput value={phone} setter={setPhone} placeholder={d('phone')} />
          </Col>
          <Col sm={12} lg={6}>
            <DropDown
              customStyle={{ height: '54px' }}
              value={inquiries}
              setValue={setInquiries}
              options={[{ label: d('general'), value: 'General' }]}
              placeholder={d('type')}
              indicatorColor="var(--secondary-clr)"
            />
          </Col>
          <Col md={12}>
            <TextArea value={description} setValue={setDescription} placeholder={d('message')} />
          </Col>
          <Col md={12} className={classes.btnCenter}>
            <Button label={d('btnText')} variant="secondary" onClick={handleSubmit} />
          </Col>
        </Row>
      </Container>
      <Footer showDownload={false} />
    </div>
  );
};

export default ContactUs;
